export default {
  name: "ຊື່",
  tel: "ໂທລະສັບ",
  save: "ປະຢັດ",
  confirm: "ຢືນຢັນ",
  cancel: "ຍົກເລີກ",
  delete: "ລົບ",
  complete: "ສໍາເລັດຮູບ",
  loading: "ກໍາລັງໂຫລດ ...",
  telEmpty: "ກະລຸນາຕື່ມໃສ່ເບີໂທລະສັບຂອງທ່ານ",
  nameEmpty: "ກະລຸນາຕື່ມໃສ່ຊື່ຂອງທ່ານ",
  nameInvalid: "ກະລຸນາໃສ່ຊື່ທີ່ຖືກຕ້ອງ",
  confirmDelete: "ທ່ານແນ່ໃຈບໍ່ວ່າທ່ານຕ້ອງການລຶບມັນ",
  telInvalid: "ກະລຸນາໃສ່ເບີໂທລະສັບທີ່ຖືກຕ້ອງ",
  vanCalendar: {
    end: "ສໍາເລັດຮູບ",
    start: "ຊູບ",
    title: "ໃບຕາດິນ",
    confirm: "ຢືນຢັນ",
    startEnd: "ເລີ່ມຕົ້ນສິ້ນສຸດ",
    weekdays: {
      "0": "ວັນ",
      "1": "ຫນື່ງ",
      "2": "ສອງ",
      "3": "ສາມ",
      "4": "ສີ່",
      "5": "ຫ້າ",
      "6": "ຫົກ"
    }
  },
  vanCascader: { select: "ກະລຸນາເລືອກ" },
  vanContactCard: { addText: "ເພີ່ມຕິດຕໍ່" },
  vanContactList: { addText: "ຜູ້ຕິດຕໍ່ໃຫມ່" },
  vanPagination: { prev: "ຫນ້າກ່ອນຫນ້ານີ້", next: "ຫນ້າຕໍ່ໄປ" },
  vanPullRefresh: {
    pulling: "ດຶງລົງເພື່ອໂຫຼດຫນ້າຈໍຄືນ ...",
    loosing: "ປ່ອຍຄືນໃຫມ່ ..."
  },
  vanSubmitBar: { label: "ທັງຫມົດ:" },
  vanCoupon: { unlimited: "ບໍ່ມີຂໍ້ຈໍາກັດດ້ານການນໍາໃຊ້" },
  vanCouponCell: { title: "ຄູປອງ", tips: "ບໍ່ມີ" },
  vanCouponList: {
    empty: "ບໍ່ມີ Coupons",
    exchange: "ແລກກັນ",
    close: "ບໍ່ມີ Coupons",
    enable: "ມີໄວ້",
    disabled: "ບໍ່ມີ",
    placeholder: "ກະລຸນາໃສ່ລະຫັດຫຼຸດລາຄາ"
  },
  vanAddressEdit: {
    area: "ພື້ນທີ່",
    postal: "ລະຫັດໄປສະນີ",
    areaEmpty: "ເລືອກພາກພື້ນ",
    addressEmpty: "ກະລຸນາຕື່ມໃສ່ທີ່ຢູ່ລະອຽດ",
    postalEmpty: "ຮູບແບບລະຫັດໄປສະນີແມ່ນບໍ່ຖືກຕ້ອງ",
    defaultAddress: "ກໍານົດເປັນທີ່ຢູ່ສົ່ງສິນຄ້າເລີ່ມຕົ້ນ",
    telPlaceholder: "ເບີໂທລະສັບມືຖື consignee",
    namePlaceholder: "ຊື່ຂອງ Consignee",
    areaPlaceholder: "ເລືອກແຂວງ / ເມືອງ / ເມືອງ / ເມືອງ"
  },
  vanAddressEditDetail: {
    label: "ທີ່ຢູ່",
    placeholder: "ຈໍານວນປະຕູຕາມຖະຫນົນ, ຈໍານວນຫ້ອງຊັ້ນແລະຂໍ້ມູນອື່ນໆ"
  },
  vanAddressList: { add: "ເພີ່ມທີ່ຢູ່" }
};
